export default __webpack_public_path__ + "static/media/self-service-hero.1de9578d.svg";